import { useEffect, useState } from "react";
import { Folder, Briefcase, Clock, FileText } from "lucide-react";
import useLocalStorageState from "use-local-storage-state";
import { Link, useNavigate } from "react-router-dom";
import { DeleteRequest, GetRequest } from "../../Utils/hooks/ApiHandler";
import { toast } from "sonner";
import pugCrm_favicon from "../../Utils/assets/img/pugCrm_favicon.png";
import { useGetRequest } from "../../Utils/hooks/QueryHandler";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical, faPlus } from "@fortawesome/free-solid-svg-icons";
import { baseURL, defaultImage, imageURL } from "../../Utils/constants/constant";
import { formatDate } from "../../Utils/helpers/commonhelper";
import { ProjectDetails } from "../../Pages/project/ProjectDetails";
import { CreateProject } from "../../Pages/project/CreateProject";
import { Button, Dropdown, Nav, Spinner } from "react-bootstrap";
import DeleteModal from "../../Pages/DeleteModal";
import { useGetEssentials } from "../../Utils/hooks/useGetEssentials";

export const ProjectDashboard = () => {
  const { headers, extras, customerId, loginUserId } = useGetEssentials()
  const [cardData, setCardData] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [search, setSearch] = useState("");
  const [inputSearch, setInputSearch] = useState("");
  const [show, setShow] = useState(false);
  const [showProjectCanvas, setProjectOffcanvas] = useState(false);
  const [projectIdForDetailPage, setProjectIdForDetailPage] = useState(null);
  const [editedMode, setEditMode] = useState(false);
  const [project_id, setProject_id] = useState();
  const [departmentToDelete, setDepartmentToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // delete modal loading state
  const [isDeleting, setIsDeleting] = useState(false)

  const params = {
    search: search,
  };

  const {
    data: projectListData,
    error,
    refetch: fetchProjectListData,
    isLoading,
    isError,
  } = useGetRequest(
    `/project/projectList/${customerId}/${loginUserId}`,
    "getProjectList",
    headers,
    extras,
    params
  );

  console.log(projectData, "project data ");

  useEffect(() => {
    if (
      projectListData?.status === "fail" ||
      projectListData?.status !== "success"
    ) {
      setProjectData([]);
    }
    if (projectListData?.status === "success") {
      setProjectData(projectListData.data);
    } else if (isError) {
      console.error("Error fetching roles:", error);
    }
  }, [projectListData, isError]);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearch(inputSearch.trim());
    }, 300);
    return () => clearTimeout(debounceTimer);
  }, [inputSearch]);

  const fetchCardData = async () => {
    try {
      const res = await GetRequest(
        `/project/projectCards/${customerId}/${loginUserId}`,
        { headers },
        extras
      );

      if (res.status === "fail" || res.status !== "success") {
        return toast.error(res.message);
      }

      setCardData(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCardData();
  }, []);

  useEffect(() => {
    fetchProjectListData();
  }, []);

  const handleDetailPageClicked = (project) => {
    setProjectIdForDetailPage(null);
    setProjectIdForDetailPage(project?.id);
    setShow(true);
  };

  const handleOnCloseClick = () => {
    setProjectIdForDetailPage(null);
    setShow(false);
  };

  const handleProjectEditClicked = (project) => {
    setProject_id(project?.id);
    setEditMode(true);
    setProjectOffcanvas(true);
  };

  const onDelete = (id) => {
    setDepartmentToDelete(id);
    setShowDeleteModal(true);
  };

  const handleConfirmedDelete = async () => {
    setIsDeleting(true)
    try {
      const item = projectData.find((d) => d.id === departmentToDelete);
      if (!item) return;

      const res = await DeleteRequest(
        `project/deleteProject/${departmentToDelete}/${loginUserId}`,
        { headers },
        extras
      );
      if (res?.status === "success") {
        toast.success(res.message);
        setProjectData((prev) =>
          prev.filter((d) => d.id !== departmentToDelete)
        );
        setIsDeleting(false)
        await fetchProjectListData();
      } else if (res.status === "fail") {
        toast.error(res.message);
        setIsDeleting(false)
      }
    } catch (error) {
      console.error("Delete error:", error);
      setIsDeleting(false)

    } finally {
      setShowDeleteModal(false);
      setDepartmentToDelete(null);
      setIsDeleting(false)
    }
  };
  const compare_date = Date().toLocaleString();
  return (
    <>
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmedDelete}
        isLoading={isDeleting}
        message="Are you sure you want to permanently delete this item?"
      />
      <ProjectDetails
        show={show}
        onClose={() => handleOnCloseClick()}
        projectIdForDetailPage={projectIdForDetailPage}
        setProjectIdForDetailPage={setProjectIdForDetailPage}
        moduleName={"ProjectDashboard"}
        refetch={fetchProjectListData}
      />
      <div className="dashboard-container">
        <style>{`
          * {
            font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
          }

          .dashboard-container {
            background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
            min-height: 100vh;
            padding: .25rem;
          }

          @media (max-width: 768px) {
            .dashboard-container {
              padding: .25rem;
            }
          }

          /* Stat Cards */
          .stat-card {
            background: white;
            border:1px solid #caeaf4;
            border-radius: 12px;
            padding: 1.5rem;
            font-size:11px;
            font-weight:400;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          }


          .stat-title {
            font-size: 0.875rem;
            font-weight: 500;
            color: #64748b;
            margin-bottom: 0.75rem;
            letter-spacing: 0.3px;
          }

          .stat-value {
            font-size: 1.875rem;
            font-weight: 700;
            color: #1e293b;
            margin-bottom: 0.75rem;
          }

          .stat-badge {
            font-size: 0.75rem;
            font-weight: 600;
            padding: 0.375rem 0.75rem;
            border-radius: 6px;
            display: inline-flex;
            align-items: center;
            gap: 0.375rem;
            border: 1px solid;
          }

          .stat-icon-wrapper {
            width: 48px;
            height: 48px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
          }

          /* Project Cards */
          .project-card {
            border-radius: 0.5rem;
           border: 1px solid #caeaf4;
           box-shadow: none !important;
            background: white;
            overflow: hidden;
            display: flex;
            flex-direction: column;
          }

          .project-card:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
            border-color: #e5e9f0;
          }

          .project-card-header {
            padding:1rem 1.25rem;
            border-bottom: 1px solid #f1f5f9;
            // background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          }

          .project-card-title {
            font-size: 0.95rem;
            font-weight: 600;
            color: #0d6efd;
            margin-bottom: 0.375rem;
            text-decoration: none;
            transition: color 0.2s;
          }

          .project-card-title:hover {
            color: #0b5ed7;
          }

          .project-card-subtitle {
            font-size: 0.8rem;
            color: #64748b;
            margin: 0;
          }

          .project-card-body {
            padding: 1.25rem;
            flex: 1 1 auto;
          }

          .project-card-footer {
            padding: 1rem 1.25rem;
            border-top: 1px solid #f1f5f9;
            // background: #f8fafc;
            display: flex;
            justify-content: space-between;
            gap: 1rem;
          }

          .project-section {
            margin-bottom: .6rem;
          }

          .project-section:last-child {
            margin-bottom: 0;
          }

          .section-label {
            font-size: 0.7rem;
            font-weight: 600;
            color: #475569;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 0.25rem;
          }

          .section-content {
            font-size: 0.9rem;
            color: #1e293b;
          }

          .avatar-stack {
            display: flex;
            gap: 0.375rem;
            flex-wrap: wrap;
          }

          .avatar-item {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            border: 2px solid white;
            object-fit: cover;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }

          .avatar-count {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background: #0d6efd;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.75rem;
            font-weight: 600;
            border: 2px solid white;
          }

          .priority-badge {
            font-size: 0.75rem;
            font-weight: 600;
            padding: 0.375rem 0.75rem;
            border-radius: 6px;
            display: inline-block;
            margin-top: 0.375rem;
          }

          .priority-low {
            background: #d1fae5;
            color: #065f46;
          }

          .priority-medium {
            background: #dbeafe;
            color: #0c4a6e;
          }

          .priority-high {
            background: #fee2e2;
            color: #7f1d1d;
          }

          .progress-bar-container {
            width: 100%;
            height: 6px;
            background: #e2e8f0;
            border-radius: 3px;
            overflow: hidden;
            margin: 0.75rem 0;
          }

          .progress-bar-fill {
            height: 100%;
            background: linear-gradient(90deg, #0d6efd 0%, #0b5ed7 100%);
            border-radius: 3px;
            transition: width 0.3s ease;
          }

          .progress-text {
            font-size: 0.8rem;
            font-weight: 600;
            color: #0d6efd;
          }

          .date-info {
            display: flex;
            flex-direction: column;
            gap: 0.25rem;
          }

          .date-label {
            font-size: 0.75rem;
            color: #64748b;
            font-weight: 500;
          }

          .date-value {
            font-size: 0.9rem;
            font-weight: 600;
            color: #1e293b;
          }

          /* Toolbar */
          .toolbar {
              border-radius: 0.5rem;
    border: 1px solid #caeaf4;
    box-shadow: none !important;
            background: white;
        
      
            padding: 1.25rem;
            margin-bottom: 2rem;
           
          }

          .toolbar-button {
            background: #0d6efd;
            color: white;
            border: none;
            padding: 0.625rem 1.25rem;
            border-radius: 8px;
            font-size: 0.9rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
          }

          .toolbar-button:hover {
            background: #0b5ed7;
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(13, 110, 253, 0.3);
          }

          .search-input {
            padding: 0.625rem 1rem 0.625rem 2.5rem;
            border: 1px solid #e5e9f0;
            border-radius: 8px;
            font-size: 0.9rem;
            transition: all 0.2s;
          }

          .search-input:focus {
            outline: none;
            border-color: #0d6efd;
            box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
          }

          /* Grid Layout */
          .projects-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap:  1rem;
            margin-bottom: 2rem;
          }

          @media (max-width: 1400px) {
            .projects-grid {
              grid-template-columns: repeat(1, 1fr);
              gap: 1.25rem;
            }
          }

          @media (max-width: 1024px) {
            .projects-grid {
              grid-template-columns: repeat(2, 1fr);
              gap: 1.25rem;
            }
          }

          @media (max-width: 768px) {
            .projects-grid {
              grid-template-columns: 1fr;
              gap: 1rem;
            }
          }

          .stats-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
            gap: 1.5rem;
            margin-bottom: 2rem;
          }

          @media (max-width: 768px) {
            .stats-grid {
              grid-template-columns: repeat(2, 1fr);
              gap: 1rem;
            }
          }

          @media (max-width: 480px) {
            .stats-grid {
              grid-template-columns: 1fr;
            }
          }

          /* Header */
          .dashboard-header {
            margin-bottom: 2rem;
          }

          .dashboard-title {
            font-size: 1.75rem;
            font-weight: 700;
            color: #1e293b;
            margin-bottom: 0.5rem;
          }

          .dashboard-subtitle {
            font-size: 0.95rem;
            color: #64748b;
            margin: 0;
          }

          .breadcrumb-nav {
            font-size: 0.85rem;
            color: #64748b;
          }

          .breadcrumb-nav a {
            color: #0d6efd;
            text-decoration: none;
            transition: color 0.2s;
          }

          .breadcrumb-nav a:hover {
            color: #0b5ed7;
          }

          /* Dropdown Menu */
          .dropdown-menu {
            border: 1px solid #e5e9f0;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }

          .dropdown-item {
            font-size: 0.9rem;
            padding: 0.625rem 1rem;
            transition: all 0.2s;
          }

          .dropdown-item:hover {
            background: #f1f5f9;
            color: #0d6efd;
          }
        `}</style>

        {/* Header */}
        <div className="dashboard-header">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              flexWrap: "wrap",
              gap: "1rem",
            }}
          >
            <div>
              <p className="fw-semibold fs-24 mb-0">Project Lists</p>
              <p className="fs-semibold text-muted">
                Track your day-to-day activity, leads, meetings, and deals here.
              </p>
            </div>
            <nav className="breadcrumb-nav">
              <Link
                to="/projects"
                style={{ cursor: "pointer" }}
                className="fs-14 fw-600"
              >
                Projects
              </Link>{" "}
              <span style={{ margin: "0 0.5rem" }}>»</span>{" "}
              <span className="fw-600 fs-14">Projects List</span>
            </nav>
          </div>
        </div>

        {/* Stats Row */}
        <div className="stats-grid">
          <div className="stat-card">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ flex: 1 }}>
                <p className="stat-title">Completed Projects</p>
                <h3 className="stat-value">{cardData?.completed || 0}</h3>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  {/* <span
                    className="stat-badge"
                    style={{ backgroundColor: "#d1fae5", color: "#065f46", borderColor: "#a7f3d0" }}
                  >
                    <ArrowUp size={12} />
                    1.4%
                  </span> */}
                  <span className="badge bg-success-transparent">
                    1.5%
                    <i className="ti ti-trending-up"></i>
                  </span>
                  <span style={{ fontSize: "0.8rem", color: "#64748b" }}>
                    this month
                  </span>
                </div>
              </div>
              <div
                className="stat-icon-wrapper"
                style={{ backgroundColor: "#d1fae5" }}
              >
                <FileText size={24} color="#198754" />
              </div>
            </div>
          </div>

          <div className="stat-card">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ flex: 1 }}>
                <p className="stat-title">Overdue Projects</p>
                <h3 className="stat-value">{cardData?.overdue || 0}</h3>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <span className="badge bg-danger-transparent">
                    0.23%
                    <i className="ti ti-trending-down"></i>
                  </span>
                  <span style={{ fontSize: "0.8rem", color: "#64748b" }}>
                    this month
                  </span>
                </div>
              </div>
              <div
                className="stat-icon-wrapper"
                style={{ backgroundColor: "#fee2e2" }}
              >
                <Briefcase size={24} color="#dc3545" />
              </div>
            </div>
          </div>

          <div className="stat-card">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ flex: 1 }}>
                <p className="stat-title">Total Projects</p>
                <h3 className="stat-value">{cardData?.total || 0}</h3>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <span className="badge bg-success-transparent">
                    0.67%
                    <i className="ti ti-trending-up"></i>
                  </span>
                  <span style={{ fontSize: "0.8rem", color: "#64748b" }}>
                    this month
                  </span>
                </div>
              </div>
              <div
                className="stat-icon-wrapper"
                style={{ backgroundColor: "#dbeafe" }}
              >
                <Folder size={24} color="#0d6efd" />
              </div>
            </div>
          </div>

          <div className="stat-card">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ flex: 1 }}>
                <p className="stat-title">Pending Projects</p>
                <h3 className="stat-value">{cardData?.pending || 0}</h3>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <span className="badge bg-success-transparent">
                    0.53%
                    <i className="ti ti-trending-up"></i>
                  </span>
                  <span style={{ fontSize: "0.8rem", color: "#64748b" }}>
                    this month
                  </span>
                </div>
              </div>
              <div
                className="stat-icon-wrapper"
                style={{ backgroundColor: "#fef3c7" }}
              >
                <Clock size={24} color="#ffc107" />
              </div>
            </div>
          </div>
        </div>

        {/* Toolbar */}
        <div className="toolbar">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "1rem",
            }}
          >
            <button
              className="toolbar-button"
              onClick={() => setProjectOffcanvas(true)}
            >
              + New Project
            </button>

            {showProjectCanvas && (
              <CreateProject
                show={showProjectCanvas}
                setProjectOffcanvas={setProjectOffcanvas}
                editedMode={editedMode}
                setEditMode={setEditMode}
                project_id={project_id}
                moduleName={"ProjectDashboard"}
                refetch={fetchProjectListData}
                setProject_id={setProject_id}
              />
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flex: 1,
                minWidth: "180px",
              }}
            >
              <div className="avatar-list-stacked">
                {cardData?.users?.slice(0, 4).map((member, idx) => (
                  <span className="avatar avatar-sm avatar-rounded">
                    <img
                      key={idx}
                      title={member.user_name}
                      src={
                        member.profile_img === null ||
                          member.profile_img === "null"
                          ? defaultImage
                          : `${imageURL}${member.profile_img}`
                      }
                      alt={member.name || "User"}
                      className="avatar-item"
                    />
                  </span>
                ))}

                {cardData?.users?.length > 4 && (
                  <div className="avatar avatar-sm bg-primary avatar-rounded text-fixed-white">
                    +{cardData?.users.length - 4}
                  </div>
                )}
              </div>
            </div>

            <div style={{ position: "relative", minWidth: "240px" }}>
              <i
                className="fa-solid fa-magnifying-glass"
                style={{
                  position: "absolute",
                  left: "0.75rem",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#94a3b8",
                  fontSize: "0.9rem",
                }}
              ></i>
              <input
                type="text"
                className="search-input"
                placeholder="Search Project"
                value={inputSearch}
                onChange={(e) => setInputSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    setSearch(inputSearch);
                  }
                }}
              />
              {inputSearch.length > 0 && (
                <i
                  className="fa-solid fa-xmark"
                  style={{
                    position: "absolute",
                    right: "0.75rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#94a3b8",
                    cursor: "pointer",
                    fontSize: "0.9rem",
                  }}
                  onClick={() => setInputSearch("")}
                ></i>
              )}
            </div>
          </div>
        </div>

        {/* Projects Grid */}

        <div
          className="projects-grid"
          style={
            projectData?.length === 0
              ? {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }
              : {}
          }
        >
          {isLoading ? (
            <div
              className="d-flex flex-column justify-content-center align-items-center bg-white"
              style={{
                width: "100%",
                height: "calc(100vh - 220px)",
              }}
            >
              <Spinner animation="border" variant="primary" />
            </div>
          ) : projectData?.length > 0 ? (
            projectData.map((proj, i) => (
              <div key={i} className="project-card">
                <div className="project-card-header">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      gap: "0.75rem",
                    }}
                  >
                    <div className="me-2">
                      <span
                        style={{
                          borderRadius: "50%",
                          height: "34px",
                          width: "34px",
                        }}
                        className="bg-danger-transparent avatar p-1"
                      >
                        <img
                          src={defaultImage}
                          alt=""
                          height={"30px"}
                          width={"30px"}
                          style={{ borderRadius: "50%" }}
                        />
                      </span>
                    </div>
                    <div style={{ flex: 1 }}>
                      <a
                        href="#"
                        className="fw-semibold fs-14 d-block text-truncate project-list-title"
                        onClick={() => handleDetailPageClicked(proj)}
                      >
                        {proj.project_title.length > 25
                          ? `${proj.project_title.slice(0, 25)}...`
                          : proj.project_title}
                      </a>
                      <p className="project-card-subtitle">
                        Total{" "}
                        <strong>
                          {proj.completed_task}/{proj.total_task}
                        </strong>{" "}
                        tasks completed
                      </p>
                    </div>
                    <div className="endTdDiv">
                      <Dropdown
                        as="div"
                        className="dropdownsWithoutToggle show dropdown"
                      >
                        <Dropdown.Toggle
                          as={Nav.Link}
                          className="header-link"
                          style={{ cursor: "pointer", padding: 0 }}
                        >
                          <FontAwesomeIcon
                            icon={faEllipsisVertical}
                            style={{ fontSize: "16px", color: "#64748b" }}
                          />
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          align={"end"}
                          style={{
                            width: "8rem",
                            inset: "0px auto auto 0px",
                            boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                            position: "absolute",
                            marginTop: "0px",
                            marginRight: "10px",
                            minWidth: "3rem",
                          }}
                        >
                          <Dropdown.Item
                            onClick={() => handleDetailPageClicked(proj)}
                          >
                            View
                          </Dropdown.Item>
                          <Dropdown.Item
                            href="#"
                            onClick={() => handleProjectEditClicked(proj)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            href="#"
                            onClick={() => onDelete(proj.id)}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>

                <div className="project-card-body">
                  <div
                    className="project-section"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      gap: "1rem",
                      marginBottom: "3px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <div className="section-label">Team</div>
                      <div className="avatar-list-stacked">
                        {proj.users && proj.users.length > 0 ? (
                          <>
                            {proj.users?.slice(0, 4).map((member, idx) => (
                              <span className="avatar avatar-sm avatar-rounded">
                                {" "}
                                <img
                                  key={idx}
                                  title={member?.user_name}
                                  src={
                                    member.profile_img === null ||
                                      member.profile_img === "null"
                                      ? defaultImage
                                      : `${imageURL}${member.profile_img}`
                                  }
                                  alt={member.name || "User"}
                                  className="avatar-item"
                                />
                              </span>
                            ))}
                            {proj.users?.length > 4 && (
                              <div className="avatar avatar-sm bg-primary avatar-rounded text-fixed-white">
                                +{proj.users?.length - 4}
                              </div>
                            )}
                          </>
                        ) : (
                          <>
                            <span className="avatar avatar-sm avatar-rounded">
                              <img
                                src={defaultImage || "/placeholder.svg"}
                                alt="Dummy User 3"
                                className="avatar-item"
                              />
                            </span>
                          </>
                        )}
                      </div>
                    </div>

                    <div style={{ textAlign: "right" }}>
                      <div className="section-label">Priority :</div>
                      <span
                        className="badge bg-success-transparent"
                        style={{ fontSize: "9px" }}
                      >
                        {proj.priority || "Low"}
                      </span>
                    </div>
                  </div>

                  <div className="project-section">
                    <div className="section-label">Description :</div>
                    <p className="fs-12 text-muted" title={proj?.description}>
                      {proj?.description?.length > 100
                        ? `${proj?.description.slice(0, 100)}...`
                        : proj.description}
                    </p>
                  </div>

                  <div className="project-section">
                    <div className="section-label">Status</div>
                    <div className="progress-bar-container">
                      <div
                        className="progress-bar-fill"
                        style={{ width: `${proj.percentage}%` }}
                      ></div>
                    </div>
                    <div style={{ marginTop: "0.5rem" }}>
                      <span className="progress-text">
                        {proj?.percentage.toFixed(2)}%
                      </span>{" "}
                      Completed
                    </div>
                  </div>
                </div>

                <div className="project-card-footer">
                  <div className="date-info">
                    <span className="date-label">Assigned Date</span>
                    <span className="date-value">
                      {formatDate(proj.start_date)}
                    </span>
                  </div>
                  <div className="date-info" style={{ textAlign: "right" }}>
                    <span className="date-label">Due Date</span>
                    <span
                      className={`date-value ${new Date(proj.end_date) < new Date(compare_date)
                        ? "text-danger"
                        : ""
                        }`}
                    >
                      {formatDate(proj.end_date)}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div
              className="d-flex flex-column justify-content-center align-items-center bg-white"
              style={{
                width: "100%",
                height: "calc(100vh - 220px)", // adjust if needed
              }}
            >
              <div
                className="d-flex flex-column align-items-center justify-content-center gap-3"
                style={{
                  width: "100%",
                  maxWidth: "400px",
                }}
              >
                <img
                  src={pugCrm_favicon || "/placeholder.svg"}
                  alt=""
                  height="60"
                />

                <div
                  className="d-flex flex-column justify-content-center align-items-center gap-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => setProjectOffcanvas(true)}
                >
                  <p>Create your project</p>

                  <Button
                    style={{ height: "35px" }}
                    type="button"
                    variant="default"
                    className="btn btn-default"
                    onClick={() => setProjectOffcanvas(true)}
                  >
                    <FontAwesomeIcon icon={faPlus} /> Create Project
                  </Button>
                </div>

                {showProjectCanvas && (
                  <CreateProject
                    show={showProjectCanvas}
                    setProjectOffcanvas={setProjectOffcanvas}
                    editedMode={editedMode}
                    setEditMode={setEditMode}
                    project_id={project_id}
                    moduleName={"ProjectDashboard"}
                    refetch={fetchProjectListData}
                    setProject_id={setProject_id}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
